import {
	V2_APPLICANT_SOURCES_PATH,
	V2_CANDIDATE_ACCESS_PATH,
	V2_CONFIGURATION_PATH,
	V2_HOT_CANDIDATES_PATH,
	V2_JOB_ALERTS_PATH,
	V2_NOTIFICATION_SETTINGS_PATH,
	V2_REPORTS_PATH,
	V2_ROLES_PATH,
	V2_SEGMENTS_PATH,
	V2_TEMPLATES_PATH,
	V2_WORKFLOWS_PATH,
} from '~/common/constants/v2-hosted-path'

/*
 * Every URL Maestro V2 owns lives under one prefix, so V1 routes are never
 * touched and a recruiter can tell from the address bar which version they are
 * on. `careStore` registers the single feature at `PATHS.recruiter.v2` and this
 * feature routes everything beneath it.
 */
export const V2_BASE = '/v2'

export const V2_PATHS = {
	base: V2_BASE,
	today: `${V2_BASE}/today`,
	jobs: `${V2_BASE}/jobs`,
	jobDetail: (id) => `${V2_BASE}/jobs/${id}`,
	candidates: `${V2_BASE}/candidates`,
	candidateDetail: (id) => `${V2_BASE}/candidates/${id}`,
	pipeline: `${V2_BASE}/pipeline`,
	credentials: `${V2_BASE}/credentials`,
	messages: `${V2_BASE}/messages`,
	// One in-app conversation, opened in the Messages page (same shape as its own links).
	conversation: (id) => `${V2_BASE}/messages/${id}`,
	help: `${V2_BASE}/help`,
	// Global search results, inside the V2 shell (Classic's page, same URL shape).
	search: `${V2_BASE}/search`,
	// Classic screens that must stay inside the V2 shell: the bell's "View all",
	// the account menu's Profile, and an internal user's page. Same pages, V2 frame.
	notifications: `${V2_BASE}/notifications`,
	profile: `${V2_BASE}/profile`,
	users: `${V2_BASE}/users`,
	// Reports & Analytics and Configuration, the same pages as Classic. Configuration's
	// cards open the screens beneath `configuration`, still inside this shell.
	reports: V2_REPORTS_PATH,
	// Where applications come from (SPT-2326): Source / Creator / Campaign across every job.
	applicantSources: V2_APPLICANT_SOURCES_PATH,
	configuration: V2_CONFIGURATION_PATH,
	workflows: V2_WORKFLOWS_PATH,
	templates: V2_TEMPLATES_PATH,
	notificationSettings: V2_NOTIFICATION_SETTINGS_PATH,
	hotCandidates: V2_HOT_CANDIDATES_PATH,
	segments: V2_SEGMENTS_PATH,
	roles: V2_ROLES_PATH,
	candidateAccess: V2_CANDIDATE_ACCESS_PATH,
	userDetail: (id) => `${V2_BASE}/users/${encodeURIComponent(id)}`,
	// The recruiter's own job-area alerts (SPT-2331), opened from the account menu.
	jobAlerts: V2_JOB_ALERTS_PATH,
	jobAlertNew: `${V2_JOB_ALERTS_PATH}/new`,
}

export const MAESTRO_VERSION = {
	classic: 'classic',
	v2: 'v2',
}
